// extracted by mini-css-extract-plugin
export default {"loadingContainer":"loader_loadingContainer__uS20f","withNoOverlay":"loader_withNoOverlay__GqAIZ","loader":"loader_loader__oqE+S","rotate":"loader_rotate__qeexE"};